import { z } from 'zod';
import { CAL_EVENT_TEMPLATE_TEXT_MAX_LENGTH } from '../../events/cal-event-template-text-max-length.js';
import { optionalUuidString } from '../zod-helpers/index.js';
export const calEventFieldValueInputSchema = z.object({
    fieldKey: z.string().trim().min(1, 'Field is required.').max(64, 'Invalid field.'),
    text: z
        .string()
        .max(CAL_EVENT_TEMPLATE_TEXT_MAX_LENGTH, `Value must be ${CAL_EVENT_TEMPLATE_TEXT_MAX_LENGTH} characters or fewer.`)
        .nullish(),
    number: z.number().finite('Enter a number.').nullish(),
    date: z.string().max(40, 'Enter a valid date.').nullish(),
    option: z.string().max(128, 'Invalid option.').nullish(),
    entityId: optionalUuidString('Invalid reference.').nullish(),
});
//# sourceMappingURL=cal-event-field-value-input.js.map